import React from 'react'
import AmbulatoryOrderDetailsLayout from 'presentation/doctor/layouts/AmbulatoryOrderDetails'

function AmbulatoryOrdersDetails() {
  return <AmbulatoryOrderDetailsLayout />
}

export default AmbulatoryOrdersDetails
